export default __webpack_public_path__ + "media/images/54-9a0b08928ce3ac71a1eeb27e9e05ea6c.jpg";